import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const dropdown = (theme: Theme) => css`
  ${breakpoint.up('lg')} {
    width: 100vw;
    max-width: 100vw;
    position: fixed;
    background: #fff;
    left: 0;
    top: ${size[90]};
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
    border-top: 1px solid rgba(156, 145, 158, 0.12);
    background: ${theme.palette.background.main};
  }
`

export const container = css`
  width: ${width.container.large};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  ${breakpoint.up('lg')} {
    padding: ${size[54]} ${size[72]};
  }
`

export const links = css`
  ${breakpoint.up('smMd')} {
    max-width: ${width.container.large};
    padding-left: ${size[20]};
    padding-right: ${size[20]};
    padding-top: ${size[20]};
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 0px auto;
  }

  ${breakpoint.up('lg')} {
    padding-top: 0px;
    display: grid;
    grid-template-columns: repeat(3, minmax(min-content, 1fr));
    gap: ${size[48]};
  }
`
